import { leadingNone } from '@ui/typography/styles'
import { TypographyProps } from '@ui/typography/types'
import cn from '@ui/utils/cn'

export type DetailRowSize = 'xs' | 'sm' | 'md'

export const heightVariantMap: Record<DetailRowSize, number> = {
  xs: 72,
  sm: 80,
  md: 96,
}

export const titleVariantMap: Record<DetailRowSize, TypographyProps> = {
  xs: { variant: 'SM', className: cn(leadingNone, 'font-text-semibold') },
  sm: { variant: 'SMB', className: 'font-text-semibold' },
  md: { variant: 'MDB', className: '' },
}
